// useDecimalInput.js
import { useEffect } from 'react';

const useDecimalInput = (inputRef) => {
  const handleKeyDown = (e) => {
    // Regular expression to match numbers, a minus sign, and a decimal point
    const decimalPattern = /^[0-9.-]$/;
    // List of allowed keys including navigation and editing keys
    const allowedKeys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Backspace', 'Delete'];

    if (!decimalPattern.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keydown', handleKeyDown);
      return () => {
        inputRef.current.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [inputRef]);

  return handleKeyDown;
};

export default useDecimalInput;
